import React, { useContext } from "react";
import { observer } from "mobx-react";
import classnames from "classnames";

import { EventContext } from "@gp/components";

import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";

const EventNotificationButton = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function EventNotificationsButton() {
			const event = useContext(EventContext);
			const {
				notificationFavoritesStore: {
					userFavoriteNotificationEventSet,
					shouldDisplayNotificationFavoriteButton,
					toggleEventFavoriteStatus,
				},
			} = useRootAppStore();

			if (!shouldDisplayNotificationFavoriteButton) {
				return null;
			}

			const isFavorite = userFavoriteNotificationEventSet.has(event.id);

			return (
				<button
					className="btn btn--square btn--square--sml btn--ghost"
					onClick={() => toggleEventFavoriteStatus(event.id)}
				>
					<i
						className={classnames(
							"event__actions__icon u-icon u-icon--xsml btn__icon",
							{
								"u-icon--bell-on": isFavorite,
								"u-icon--bell-off": !isFavorite,
							}
						)}
					/>
				</button>
			);
		});

export default EventNotificationButton;
